import { Currency } from './currency';
import type { Coin } from './coin';

export enum CoinInfoLinkType {
  WEB
}

export interface CoinInfoLink {
  key: CoinInfoLinkType
  link: String
}

export interface CoinInfoTag {
  name: String
  slug: String
  category: String
}

export interface CoinInfoQuote {
  currency: Currency
  marketCap: Coin
  tradeVolume24hour: Coin
  fullyDilutedValue: Coin
}
export interface CoinInfoMetadata {
  maxSupply: Coin
  circulatingSupply: Coin
  circulatingSupplyPercentage: Number
  tags: CoinInfoTag[]
  rank: Number
  quote: CoinInfoQuote
  smartContractAudit: SmartContractAudit
  issuanceDate: String
}
export interface CoinInfo {
  text: String
  links: CoinInfoLink[]
  cryptocurrency: Currency
  metadata: CoinInfoMetadata
}

export interface SmartContractAudit{
  auditor: String
  link: String
  date: Date
}

export interface CoinRating {
  level: String
  score: String
  underlyingTechnologySecurity: String
  ecosystemDevelopment: String
  roadmapProgress: String
  tokenEconomics: String
  teamPartnersInvestors: String
  tokenPerformance: String
  cryptocurrency: Currency
  badge: String
}

export enum CoinRatingBadge {
  GOOD = 'good',
  OK = 'ok',
  BAD = 'bad'
}

export enum TokenRatingType {
  TS = 'T_S',
  GP = 'G_P',
  TE = 'T_E',
  LP = 'L_P',
  SK = 'S_K',
  ES = 'E_S'
}
